import {useDispatch} from 'react-redux';


import * as configActions from '../../Config/configActions';

import configService from '../../../../services/ConfigService';
import useUser from './useUser';


/**
 * Updates the user and dispatches the updated version
 *
 * @return {(function(*): void)|*}
 */
function useUpdateUser() {

    const dispatch = useDispatch();
    const userConfig = useUser();

    return updatedUserConfig => {

        (async () => {

            const updateUserConfigResponse = await configService.updateUserConfig(updatedUserConfig);

            if (updateUserConfigResponse.isSuccessful()) {

                const updatedConfig = {
                    ...userConfig,
                    ...updatedUserConfig
                };
                dispatch(configActions.onUserConfigLoaded(updatedConfig));
            }
        })();
    };
}


export default useUpdateUser;
